'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

const getRegisterManagerOptions = () => ({
    recaptchaSiteKey: Odigeo.UserArea.recaptchaSiteKey,
});

module.exports = createWidgetFactory({
    name: 'register_manager',
    modelClass: require('./model'),
    viewClass: require('./view'),

    options: {
        'register-manager': getRegisterManagerOptions(),
    },

    methods: {
        registerOk(data) {
            this.onRegisterSuccess(data);
        },

        registerWithError(data) {
            this.onRegisterError(data);
        },

        registerError(data) {
            this.onRegisterError(data);
        },

        attachSocialLoginButton(data) {
            this.onAttachSocialLoginButton(data);
        },

        closeLoginForm(data) {
            this.onCloseLoginForm(data);
        },

        registerWithFacebookOk(data) {
            this.onRegisterSuccessFacebook(data);
        },

        registerWithFacebookWithError(data) {
            this.onRegisterErrorFB(data);
        },

        registerWithFacebookError(data) {
            this.onRegisterErrorFB(data);
        },

        registerWithGoogleOk(data) {
            this.onRegisterSuccessGoogle(data);
        },

        registerWithGoogleWithError(data) {
            this.onRegisterErrorGoogle(data);
        },

        registerWithGoogleError(data) {
            this.onRegisterErrorGoogle(data);
        },

        updateAccountInfoOk(data) {
            this.onUpdateAccountInfoSuccess(data);
        },

        updateAccountInfoWithError(data) {
            this.onUpdateAccountInfoError(data);
        },

        updateAccountInfoError(data) {
            this.updatePaxWithSocialProfile(data);
        },

        renderCaptcha(data) {
            this.renderCaptcha(data);
        },
    },
});
